import React from "react";
import { Bar } from "react-chartjs-2";

export default function Barchart({ options, data }) {
  return (
    <div style={{ height: "400px" }}>
      <Bar data={data} options={options} height={400} />
    </div>
  );
}
